import { useEffect } from 'react'

const useKeyPress = (
    callback: () => void,
    keyCodes: string[],
    deps?: any[]
): void => {
    const handler = ({ code }: KeyboardEvent) => {
        if (keyCodes.includes(code)) {
            callback()
        }
    }

    useEffect(() => {
        window.addEventListener('keydown', handler)
        return () => {
            window.removeEventListener('keydown', handler)
        }
    }, deps ?? [])
}

export default useKeyPress
